export default __webpack_public_path__ + "static/1-67f07b982ca6da0ec4f227eeba533095.jpg";